/* custom.js — WorldSuperStorez Warehouse theme */
(function () {
  'use strict';

  /* ──────────────────────────────────────────────────────────────
     1. MOBILE HEADER: force search bar always visible
     The Warehouse theme hides the search input on mobile when
     show_condensed_search=true. We override this by removing
     the height/opacity restrictions and showing the search row.
  ────────────────────────────────────────────────────────────── */
  function enforceMobileSearch() {
    if (window.innerWidth > 767) return;
    var wrapper = document.querySelector('.header__search-bar-wrapper');
    if (!wrapper) return;
    // Remove any inline styles the theme sets to hide it
    wrapper.style.cssText = [
      'display:block',
      'opacity:1',
      'max-height:none',
      'height:auto',
      'visibility:visible',
      'pointer-events:auto',
      'position:static',
      'transform:none',
      'transition:none'
    ].join(';');
    // Also hide the condensed search icon
    var toggleIcon = document.querySelector('.header__action-item a[data-action="toggle-search"]');
    if (toggleIcon) {
      var iconItem = toggleIcon.closest('.header__action-item');
      if (iconItem) iconItem.style.display = 'none';
    }
  }

  /* ──────────────────────────────────────────────────────────────
     2. MOBILE TRUST STRIP
     Injects "⭐⭐⭐⭐⭐ 100% AUTHENTIC FRAGRANCES" bar between
     the header and the first page section on mobile.
  ────────────────────────────────────────────────────────────── */
  function injectMobileTrustStrip() {
    if (window.innerWidth > 767) return;
    if (document.getElementById('wss-mob-trust')) return;
    var headerSection = document.querySelector('#shopify-section-header');
    if (!headerSection) return;

    var strip = document.createElement('div');
    strip.id = 'wss-mob-trust';
    strip.className = 'wss-mob-trust';
    strip.innerHTML = [
      '<span class="wss-mob-trust__stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span>',
      '<span>100% AUTHENTIC FRAGRANCES &nbsp;&bull;&nbsp; SAME DAY DISPATCH</span>'
    ].join('');
    headerSection.after(strip);
  }

  /* ──────────────────────────────────────────────────────────────
     3. WISHLIST badge update
  ────────────────────────────────────────────────────────────── */
  function updateWishlistBadge() {
    try {
      var items = JSON.parse(localStorage.getItem('wss_wishlist') || '[]');
      var badge = document.getElementById('wss-wishlist-badge');
      if (!badge) return;
      if (items.length > 0) {
        badge.textContent = items.length;
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    } catch (e) {}
  }

  /* ──────────────────────────────────────────────────────────────
     4. Recently viewed tracker
  ────────────────────────────────────────────────────────────── */
  function trackRecentlyViewed() {
    if (window.theme && window.theme.pageType !== 'product') return;
    try {
      var handle = window.location.pathname.replace('/products/', '').replace(/\//g, '');
      if (!handle) return;
      var key = 'wss_recently_viewed';
      var list = JSON.parse(localStorage.getItem(key) || '[]');
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      if (list.length > 12) list = list.slice(0, 12);
      localStorage.setItem(key, JSON.stringify(list));
    } catch (e) {}
  }

  /* ──────────────────────────────────────────────────────────────
     INIT
  ────────────────────────────────────────────────────────────── */
  function init() {
    enforceMobileSearch();
    injectMobileTrustStrip();
    updateWishlistBadge();
    trackRecentlyViewed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('wss:wishlist:changed', updateWishlistBadge);

  /* Re-enforce on resize */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      enforceMobileSearch();
    }, 150);
  });

})();
